import React from 'react'
import {Modal, Button, Spinner} from 'react-bootstrap'
import {useI18n} from '../../../../../Utils/_helpers/useI18n'

interface ResumeInstanceModalProps {
  show: boolean
  onHide: () => void
  onConfirm: () => void
  isResuming: boolean
}

const ResumeInstanceModal: React.FC<ResumeInstanceModalProps> = ({
  show,
  onHide,
  onConfirm,
  isResuming,
}) => {
  const {t} = useI18n()
  return (
    <>
      <Modal show={show} onHide={onHide} centered>
        <Modal.Header closeButton>
          <Modal.Title className='fs-5 text-success'>
            <i className='bi bi-play-circle me-2'></i>
            {t('FLOW.LOGS.RESUME_INSTANCE')}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className='d-flex flex-column gap-3'>
            <div className='d-flex align-items-center gap-2'>
              <i className='bi bi-check-circle text-success'></i>
              <span>{t('FLOW.INSTANCE.RESUME_JOB_SUCCESS')}</span>
            </div>
            <div className='d-flex align-items-center gap-2'>
              <i className='bi bi-arrow-clockwise text-info'></i>
              <span>{t('FLOW.INSTANCE.RESUME_JOB_SUCCESS_DESC')}</span>
            </div>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <Button variant='light' onClick={onHide}>
            {t('COMMON.ACTIONS.CANCEL')}
          </Button>
          <Button variant='success' onClick={onConfirm} disabled={isResuming}>
            {isResuming ? (
              <>
                <Spinner animation='border' size='sm' className='me-2' />
                Resuming...
              </>
            ) : (
              t('FLOW.LOGS.RESUME_INSTANCE')
            )}
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  )
}

export default ResumeInstanceModal
